import React, { useEffect, useState } from 'react';
import { listenDailyWindows, saveDailyWindows } from './api';
import { todayIso } from './calendarMath';

// "He books you" — the parent posts 2-3 free windows each morning
// ("I'm free 9:30, 11:00, 1:30"), the student sees them next to any tile
// with needsParent: true (NeedsADay.jsx, TodayPage.jsx). Firestore doc,
// not a push notification — the student checks it, same as everything else
// in this module.
export default function WindowsTab({ familyData }) {
  const [doc, setDoc] = useState(undefined);
  const [w1, setW1] = useState('');
  const [w2, setW2] = useState('');
  const [w3, setW3] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!familyData?.id) return;
    return listenDailyWindows(familyData.id, d => {
      setDoc(d);
      if (d?.date === todayIso()) {
        setW1(d.windows?.[0] || '');
        setW2(d.windows?.[1] || '');
        setW3(d.windows?.[2] || '');
      }
    });
  }, [familyData?.id]);

  const isToday = doc?.date === todayIso();

  async function save() {
    if (!familyData?.id) return;
    setSaving(true);
    try {
      const windows = [w1, w2, w3].map(w => w.trim()).filter(Boolean);
      await saveDailyWindows(familyData.id, todayIso(), windows);
    } finally {
      setSaving(false);
    }
  }

  if (doc === undefined) return <p className="settings-note">Loading…</p>;

  return (
    <div>
      <p className="settings-note" style={{ marginTop: 12 }}>
        Post 2-3 times you're free today for scribing, reading aloud, or lab setup —
        the student sees these next to anything that needs you.
      </p>
      {isToday && doc.windows?.length > 0 && (
        <p className="settings-note" style={{ color: 'var(--good)' }}>
          Currently posted for today: {doc.windows.join(', ')}
        </p>
      )}
      <div className="form-row">
        <input className="input" placeholder="e.g. 9:30" value={w1} onChange={e => setW1(e.target.value)} />
        <input className="input" placeholder="e.g. 11:00" value={w2} onChange={e => setW2(e.target.value)} />
        <input className="input" placeholder="e.g. 1:30" value={w3} onChange={e => setW3(e.target.value)} />
      </div>
      <button className="btn btn--primary" style={{ marginTop: 12 }} disabled={saving} onClick={save}>
        {saving ? 'Saving…' : 'Post today\'s windows'}
      </button>
    </div>
  );
}
